// Device Controls Page Translations
// Supported languages: English (en), Danish (da)
const controlTranslations = {
  en: {
    title: "Device Controls",
    heading: "Cleaning zones",
    driveToDock: "DRIVE TO CHARGING STATION",
    cancelDocking: "CANCEL DOCKING",
    robotStatus: "Robot Status",
    cleaningIntensity: "Cleaning Intensity",
    operatingState: "State",
    battery: "Battery",
    support: "SUPPORT",
    currentzone: "Current zone",
    multiClean: "Multi Clean",

    // Device status translations
    status: {
      charging: "Charging",
      charged: "Charged",
      cleaning: "Cleaning",
      cleaningzone: "Cleaning",
      stopped: "Stopped",
      idle: "Idle",
      error: "Error",
      returning: "Returning",
      unavailable: "Unavailable",
    },

    // Button action labels
    buttonStatus: {
      start: "Start",
      stop: "Stop",
      resume: "Resume",
      disabled: "Disabled",
      select: "Select",
      cancel: "Cancel",
      tapSelect: "Tap to select",
      selected: "Selected",
    },

    cleaningLevelSlider: {
      label: "Cleaning Intensity",
      low: "Low",
      medium: "Medium",
      high: "High",
      veryHigh: "Very High",
      fast: "Quick",
      normal: "Normal",
      intense: "Intense",
    },

    // Support modal translations
    supportModal: {
      title: "Contact Support",
      description: "Please provide a short message for our team:",
      supportMessageLabel: "Support Message",
      cancel: "Cancel",
      send: "Send Support Request",
      success: "Support request sent successfully!",
      close: "Close",
      sendingSupportRequest: "Sending support request...",
      success: "Support request sent successfully!",
      error: "Error sending support request. Please try again.",
    },

    // Loading modal translations
    loadingModal: {
      gettingReady: "Getting ready to clean...",
      returningToDock: "Returning to dock...",
      stopping: "Stopping in progress...",
      resuming: "Resuming cleaning...",
      pleaseWait: "Please wait...",
      actionNotPossible: "Action is not possible at this time",
      sendingSupportRequest: "Sending support request...",
    },

    // Feedback Modal translations
    feedbackModal: {
      title: "How clean is the floor this morning?",
      description: "",
      submitLabel: "Submit Feedback",
      closeLabel: "Later",
      savingLabel: "Saving...",
      experiencePrompt: "What best describes your experience?",
      experienceCommentLabel: "Additional comment (optional)",
      experienceOptions: {
        gumOnFloor: "Gum on floor",
        dockingIssue: "Docking issue",
        dirtyEdges: "Dirty edges",
        streaks: "Streaks",
        doorIssue: "Door issue",
        controlsIssue: "Controls issue",
      },
    },

    manualModeModal: {
      title: "Manual mode activated",
      description:
        "Device controls cannot be used while the robot is in manual mode. Please lower the handlebar on the robot to use these controls.",
    },

    modalStatus: {
      charging: "Charging...",
      charged: "Charged",
      docked: "Docked",
      undocking: "Undocking...",
      cleaning: "Cleaning...",
      resting: "Resting",
      idle: "Idle",
      stationary: "Stationary",
      error: "Error",
      fault: "Fault",
      returning: "Returning...",
      dockingInProgress: "Docking...",
      dockingMove: "Moving to dock...",
      stopped: "Stopped",
      paused: "Paused",
      dockingPaused: "Docking paused",
      cleaningPaused: "Cleaning paused",
      teleoping: "Remote control",
      teleopClean: "Remote cleaning",
    },

    // General translations
    loading: "Loading...",
    error: "Error occurred",
    noZones: "Robot not currently configured with cleaning zones",
    cancel: "Cancel",
    send: "Send",
  },

  da: {
    title: "Fjernstyring",
    heading: "Områder",
    driveToDock: "KØR TIL LADESTATION",
    cancelDocking: "AFBRYD DOCKNING",
    support: "TILKALD FJERNSUPPORT",
    robotStatus: "Robotstatus",
    operatingState: "Status",
    battery: "Batteri",
    cleaningIntensity: "Rengøringsintensitet",
    currentzone: "Nuværende område",
    multiClean: "Multi-Rengøring",

    // Device status translations
    status: {
      charging: "Oplader",
      charged: "Opladet",
      cleaning: "Rengører",
      cleaningzone: "Rengører",
      stopped: "Stoppet",
      idle: "Inaktiv",
      error: "Fejl",
      returning: "Kører tilbage",
      unavailable: "Utilgængelig",
    },

    // Button action labels
    buttonStatus: {
      start: "Start",
      stop: "Stop",
      resume: "Genoptag",
      disabled: "Deaktiveret",
      select: "Vælg",
      cancel: "Annuller",
      tapSelect: "Tryk for at vælge",
      selected: "Valgt",
    },

    cleaningLevelSlider: {
      label: "Rengøringsintensitet",
      low: "Lav",
      medium: "Mellem",
      high: "Høj",
      veryHigh: "Meget høj",
      fast: "Hurtig",
      normal: "Normal",
      intense: "Intens",
    },
    // Support modal translations
    supportModal: {
      title: "Kontakt support",
      description: "Angiv venligst en kort besked til vores team:",
      supportMessageLabel: "Supportbesked",
      cancel: "Annuller",
      send: "Send anmodning om support",
      success: "Supportanmodning sendt med succes!",
      close: "Luk",
      sendingSupportRequest: "Sender supportanmodning...",
      success: "Supportanmodning sendt med succes!",
      error: "Fejl ved afsendelse af supportanmodning. Prøv igen.",
    },

    // Loading modal translations
    loadingModal: {
      gettingReady: "Klargører rengøring...",
      returningToDock: "Kører tilbage til ladestationen...",
      stopping: "Annullerer...",
      resuming: "Genoptager rengøring...",
      pleaseWait: "Vent venligst...",
      actionNotPossible: "Ikke muligt på nuværende tidspunkt",
      sendingSupportRequest: "Sender supportanmodning...",
    },

    // Feedback Modal translations
    feedbackModal: {
      title: "Hvor rent er gulvet i butikken her til morgen?",
      description: "",
      submitLabel: "Indsend feedback",
      closeLabel: "Senere",
      savingLabel: "Gemmer...",
      experiencePrompt: "Hvad beskriver bedst din oplevelse?",
      experienceCommentLabel: "Ekstra kommentar (valgfri)",
      experienceOptions: {
        gumOnFloor: "Tyggegummi på gulvet",
        dockingIssue: "Dokningsproblem",
        dirtyEdges: "Snavs ved kanter",
        streaks: "Striber på gulvet",
        doorIssue: "Dørproblem",
        controlsIssue: "Problem med tablet eller app",
      },
    },

    manualModeModal: {
      title: "Manuel tilstand aktiveret",
      description:
        "Fjernstyring kan ikke bruges, mens robotten er i manuel tilstand. Sænk håndtaget på robotten for at bruge disse kontroller.",
    },

    modalStatus: {
      charging: "Oplader...",
      charged: "Opladet",
      docked: "Docket",
      undocking: "Forlader ladestation...",
      cleaning: "Rengører...",
      resting: "Standby",
      idle: "Inaktiv",
      stationary: "Stationær",
      error: "Fejl",
      fault: "Defekt",
      returning: "Returnerer...",
      dockingInProgress: "Kører i ladestation...",
      dockingMove: "Kører til ladestation...",
      stopped: "Stoppet",
      paused: "Pauset",
      dockingPaused: "Dockning pauset",
      cleaningPaused: "Rengøring pauset",
      teleoping: "Fjernstyring",
      teleopClean: "Fjernrengøring",
    },

    // General translations
    loading: "Indlæser...",
    error: "Fejl opstået",
    noZones: "Robot ikke konfigureret med rengøringsområder",
    cancel: "Annuller",
    send: "Send",
  },
};

export default controlTranslations;
